import useTypedSelector from '../../common/hook/useTypedSelector';
import {
  ISendEventParam,
  ISendViewImpParam,
  sendEvent,
  sendViewImp,
} from '../../common/util/tracking';

export function useContentEvent(page: string) {
  const contentId = useTypedSelector(state => state.content.currentId);

  const sendContentEvent = ({
    page: pageParam = page,
    actionName,
    action,
    customProps,
  }: Pick<ISendEventParam, 'actionName' | 'action' | 'customProps'> & {
    page?: string;
  }) => {
    sendEvent({
      section: 'content_home',
      page: pageParam,
      actionName,
      action,
      customProps: {
        page_content_id: contentId,
        content_id: contentId,
        ...customProps,
      },
    });
  };

  const sendContentViewImp = ({
    customProps,
    viewImpContents,
  }: Pick<ISendViewImpParam, 'customProps' | 'viewImpContents'>) => {
    sendViewImp({
      section: 'content_home',
      page,
      customProps: {
        page_content_id: contentId,
        ...customProps,
      },
      viewImpContents,
    });
  };

  return {sendContentEvent, sendContentViewImp};
}
